import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, className = "", y = 36 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.75, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function ChapterTag({ index, label, dark = false }) {
  return (
    <p
      className={`text-xs font-bold uppercase tracking-[0.25em] ${
        dark ? "text-white/70" : "text-brand"
      }`}
    >
      {label}
    </p>
  );
}
